import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeByProductsReport } from "../api/getTradeByProductsReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeByProductsDataSlice";

export const downloadTradeByProductsReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeByProducts;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getTradeByProductsReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "TradeByProducts.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
